function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "6.95",
  cy: "6.95",
  r: "5.95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.768 7.263c0 1.384-1.261 2.505-2.818 2.505-1.557 0-2.818-1.121-2.818-2.505",
  strokeLinecap: "round"
}))));